<template>
  <div class="app-container">
    <div class="app-header">
      <div class="menu-top">
        <div class="menu-top-l" :style="{marginLeft: isCollapse ? '15px' : '30px'}" @click="changeMenuCollapse">
          <i class="iconfont icon-menu-list" />
          <div v-show="!isCollapse" class="icon-text">
            <span class="smart">互联网医院处方流转平台</span>
            <span class="medical">Medical Prescription Platform</span>
          </div>
        </div>
        <div class="menu-top-r">
          <div class="action-item help-center">
            <i class="el-icon-question"></i>
            <span>帮助中心</span>
          </div>
          <div
            v-if="canOrderNotify"
            class="action-item message-center"
            :class="{ active: notifyEnabled, ringing: newOrderCount > 0 }"
            @click="handleNotifyClick"
          >
            <el-badge :value="newOrderCount" :hidden="newOrderCount === 0" :max="99">
              <i :class="notifyEnabled ? 'el-icon-bell' : 'el-icon-turn-off'" />
            </el-badge>
            <span>{{ notifyEnabled ? '新订单提醒' : '提醒已关闭' }}</span>
          </div>
          <el-dropdown @command="handleDropdown" class="user-dropdown">
            <span class="el-dropdown-link">
              <div class="user-avatar">
                <i class="el-icon-user"></i>
              </div>
              <span>{{ loginName }}</span>
              <i class="el-icon-arrow-down" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="logout">
                <i class="el-icon-switch-button"></i>
                退出登录
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <div class="app-body">
      <div class="menu-l" :style="{width: menuWidth}">
        <div class="menu-card">
          <el-menu
            :default-active="defaultActiveRoute"
            class="el-menu-vertical-demo"
            :collapse="isCollapse"
            text-color="#64748b"
            active-text-color="#43AAB7"
            :router="true"
            :collapse-transition="false"
            background-color="transparent"
          >
            <el-menu-item v-for="(item,index) in menuLeft" :key="index" :index="item.route">
              <i class="iconfont left-icon" :class="item.icon" />
              <span slot="title" class="menu_title">{{ item.title }}</span>
            </el-menu-item>
          </el-menu>
        </div>
      </div>
      <div class="main-container">
        <div class="content-card">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bus from '@/bus'
import newOrderNotify from '@/utils/newOrderNotify'

export default {
  data() {
    return {
      isCollapse: false,
      menuWidth: '220px',
      loginName: '',
      menuLeft: [],
      canOrderNotify: false,
      notifyEnabled: true,
      newOrderCount: 0
    }
  },
  computed: {
    defaultActiveRoute() {
      const menu = this.menuLeft.find(item => {
        return this.$route.path.includes(item.route)
      })
      const route = menu ? menu.route : undefined
      return route
    }
  },
  created() {
    const menuArr = [{
      route: '/home',
      title: '首页概览',
      icon: 'icon-home-page'
    }]
    const routeArr = ['/home', '/pharmacist/pharmacistDrugList', '/pharmacist/pharmacistDrugDetails', '/pharmacist/synchronousHospitalDrag','/pharmacist/hospitalDrugAssociation']
    const buttonPermission = []
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.loginName = this.userInfo.loginName
    const menuList = this.userInfo.authInfoDTOS || []
    menuList.forEach(v => {
      menuArr.push({
        icon: v.icon,
        route: v.path,
        title: v.authName,
        authInfo: v.authList
      })
      routeArr.push(v.path)
      if (v.authList.length) {
        v.authList.forEach(auth => {
          buttonPermission.push(auth.permission)
          if (auth.paths.length) {
            auth.paths.forEach(path => {
              routeArr.push(path)
            })
          }
        })
      }
    })
    this.menuLeft = menuArr
    const menuRouterArr = [...new Set(routeArr)]
    localStorage.setItem('ADMIN_MENU_ROUTER', JSON.stringify(menuRouterArr))
    localStorage.setItem('BUTTON_PERMISSION', JSON.stringify(buttonPermission))
    this.canOrderNotify = buttonPermission.includes('order-view-list')
    newOrderNotify.setAccount(this.userInfo.loginName)
    this.notifyEnabled = newOrderNotify.isEnabled()
  },
  mounted() {
    bus.$on('change-user-info', () => {
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
      this.loginName = this.userInfo.loginName
    })
    if (this.canOrderNotify) {
      newOrderNotify.start(count => {
        this.newOrderCount = count
      })
    }
  },
  beforeDestroy() {
    bus.$off(['change-user-info'])
    newOrderNotify.stop()
  },
  methods: {
    // 隐藏左侧菜单
    changeMenuCollapse() {
      this.isCollapse = !this.isCollapse
      this.menuWidth = this.isCollapse ? '80px' : '280px'
    },
    // 下拉菜单事件
    handleDropdown(command) {
      if (command === 'logout') {
        newOrderNotify.stop()
        this.$api.USER.logout({ accountId: this.userInfo.accountId }).then(res => {
          localStorage.clear()
          sessionStorage.clear()
          this.$router.push({
            name: 'login'
          })
        }).catch(err => {
          console.log('err', err)
        })
      }
    },

    handleNotifyClick() {
      if (!this.notifyEnabled) {
        newOrderNotify.setEnabled(true)
        this.notifyEnabled = true
        newOrderNotify.unlockAudio()
        this.$message.success('新订单语音提醒已开启')
        return
      }
      if (!newOrderNotify.unlocked) {
        newOrderNotify.unlockAudio()
        this.$message.success('新订单语音提醒已开启')
        return
      }
      this.$confirm('关闭后将不再播放语音和弹窗提醒，是否继续？', '提示', {
        confirmButtonText: '关闭提醒',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        newOrderNotify.setEnabled(false)
        this.notifyEnabled = false
        this.newOrderCount = 0
        this.$message.info('新订单提醒已关闭')
      }).catch(() => {})
    }

  }
}
</script>

<style scoped lang="less">
.app-container {
  display: flex;
  flex-direction: column;
  background: #f8fafc;
  min-height: 100vh;
  color: #1e293b;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif;

  .app-header {
    background: #ffffff;
    height: 70px;
    display: flex;
    justify-content: center;
    width: 100%;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    border-bottom: 1px solid #e2e8f0;
    position: sticky;
    top: 0;
    z-index: 1000;

    .menu-top {
      width: 90%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;

      .menu-top-l {
        display: flex;
        align-items: center;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        padding: 8px 16px;
        border-radius: 12px;

        &:hover {
          background: rgba(67, 170, 183, 0.05);
          transform: translateY(-1px);
        }

        .iconfont {
          margin-right: 16px;
          font-size: 28px;
          color: #43AAB7;
          transition: transform 0.3s ease;
        }

        &:hover .iconfont {
          transform: rotate(180deg);
        }

        .icon-text {
          display: flex;
          flex-direction: column;

          .smart {
            font-size: 20px;
            font-weight: 700;
            letter-spacing: -0.5px;
            // 加强渐变效果
            background: linear-gradient(135deg, #43AAB7 0%, #5BC0CC 25%, #43AAB7 50%, #2B7A7B 75%, #1E5B5E 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            background-size: 200% 100%;
            animation: gradientShift 3s ease-in-out infinite;
            text-shadow: 0 0 20px rgba(67, 170, 183, 0.3);
            position: relative;
            
            &::after {
              content: '';
              position: absolute;
              left: 0;
              bottom: -2px;
              width: 100%;
              height: 2px;
              background: linear-gradient(90deg, #43AAB7, #5BC0CC, #43AAB7);
              border-radius: 1px;
              opacity: 0.6;
            }
          }

          .medical {
            font-size: 11px;
            font-weight: 500;
            color: #64748b;
            letter-spacing: 1px;
            text-transform: uppercase;
            margin-top: 4px;
          }
        }
      }

      .menu-top-r {
        display: flex;
        align-items: center;
        gap: 24px;

        .action-item {
          display: flex;
          align-items: center;
          gap: 8px;
          cursor: pointer;
          padding: 10px 16px;
          border-radius: 10px;
          transition: all 0.3s ease;
          color: #64748b;
          font-weight: 500;

          &.active {
            color: #43AAB7;
          }

          &.ringing {
            animation: notifyPulse 1.2s ease-in-out infinite;
          }

          &:hover {
            background: rgba(67, 170, 183, 0.05);
            color: #43AAB7;
            transform: translateY(-1px);
          }

          i {
            font-size: 16px;
          }
        }

        .user-dropdown {
          .el-dropdown-link {
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 8px 16px;
            border-radius: 12px;
            transition: all 0.3s ease;
            cursor: pointer;
            background: #f1f5f9;
            border: 1px solid #e2e8f0;

            &:hover {
              background: #e2e8f0;
              transform: translateY(-1px);
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
            }

            .user-avatar {
              width: 36px;
              height: 36px;
              border-radius: 50%;
              // 加强头像渐变效果
              background: linear-gradient(135deg, #43AAB7 0%, #5BC0CC 30%, #43AAB7 60%, #2B7A7B 90%);
              background-size: 300% 300%;
              animation: avatarGradient 4s ease-in-out infinite;
              display: flex;
              align-items: center;
              justify-content: center;
              color: white;
              font-size: 16px;
              box-shadow: 0 4px 15px rgba(67, 170, 183, 0.4), 
                          inset 0 1px 0 rgba(255, 255, 255, 0.2);
              position: relative;
              overflow: hidden;
              
              &::before {
                content: '';
                position: absolute;
                top: -50%;
                left: -50%;
                width: 200%;
                height: 200%;
                background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.3), transparent);
                transform: rotate(45deg);
                animation: shimmer 2s linear infinite;
              }
              
              i {
                position: relative;
                z-index: 1;
              }
            }

            span {
              color: #1e293b;
              font-weight: 600;
            }

            .el-icon-arrow-down {
              color: #64748b;
              font-size: 12px;
              transition: transform 0.3s ease;
            }

            &:hover .el-icon-arrow-down {
              transform: rotate(180deg);
            }
          }
        }
      }
    }
  }

  .app-body {
    width: 90%;
    margin: 0 auto;
    display: flex;
    flex: 1;
    gap: 24px;
    padding: 24px 0;
    min-height: 0;
    // 确保高度一致
    align-items: stretch;

    .menu-l {
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

      .menu-card {
        background: #ffffff;
        border-radius: 16px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
        border: 1px solid #e2e8f0;
        overflow: hidden;
        // 修复高度问题 - 使用固定高度
        height: calc(100vh - 118px);
        display: flex;
        flex-direction: column;

        .el-menu {
          border-right: none;
          background: transparent;
          padding: 12px 8px;
          flex: 1;
          overflow-y: auto;

          .el-menu-item {
            margin: 4px 0;
            border-radius: 12px;
            border: none;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            position: relative;
            overflow: hidden;

            &::before {
              content: '';
              position: absolute;
              left: 0;
              top: 0;
              width: 4px;
              height: 100%;
              background: transparent;
              transition: all 0.3s ease;
            }

            &:hover {
              background: rgba(67, 170, 183, 0.05);
              transform: translateX(4px);
              color: #43AAB7;

              &::before {
                background: #43AAB7;
              }
            }

            &.is-active {
              background: rgba(67, 170, 183, 0.08);
              color: #43AAB7;
              font-weight: 600;
              transform: translateX(4px);
              box-shadow: 0 2px 8px rgba(67, 170, 183, 0.1);

              &::before {
                background: #43AAB7;
              }
            }

            .left-icon {
              margin-right: 12px;
              font-size: 18px;
              transition: transform 0.3s ease;
            }

            &:hover .left-icon,
            &.is-active .left-icon {
              transform: scale(1.1);
            }

            .menu_title {
              font-weight: 500;
            }
          }
        }
      }
    }

    .main-container {
      flex: 1;
      min-width: 0;
      // 确保高度一致
      display: flex;
      flex-direction: column;

      .content-card {
        background: #ffffff;
        border-radius: 16px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
        border: 1px solid #e2e8f0;
        // 修复高度问题 - 使用固定高度
        height: calc(100vh - 118px);
        padding: 0;
        overflow: hidden;
        display: flex;
        flex-direction: column;

        // 为 router-view 内容添加样式
        > * {
          flex: 1;
          overflow: auto;
          padding: 24px;
        }
      }
    }
  }
}

// 添加动画效果
@keyframes notifyPulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.04);
  }
}

@keyframes gradientShift {
  0%, 100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

@keyframes avatarGradient {
  0%, 100% {
    background-position: 0% 50%;
  }
  25% {
    background-position: 100% 0%;
  }
  50% {
    background-position: 100% 100%;
  }
  75% {
    background-position: 0% 100%;
  }
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%) translateY(-100%) rotate(45deg);
  }
  100% {
    transform: translateX(100%) translateY(100%) rotate(45deg);
  }
}

// 下拉菜单样式
:deep(.el-dropdown-menu) {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  padding: 8px;

  .el-dropdown-menu__item {
    border-radius: 8px;
    padding: 12px 16px;
    transition: all 0.3s ease;
    color: #64748b;
    font-weight: 500;

    i {
      margin-right: 8px;
      color: #ef4444;
    }

    &:hover {
      background: rgba(239, 68, 68, 0.05);
      color: #ef4444;
    }
  }
}

// 响应式设计
@media (max-width: 1200px) {
  .app-container .app-body {
    width: 95%;
  }
}

@media (max-width: 1366px), (max-height: 720px) {
  .app-container {
    .app-header {
      height: 56px;

      .menu-top {
        width: 98%;
        padding: 0 12px;

        .menu-top-l {
          padding: 4px 10px;

          .iconfont {
            font-size: 24px;
            margin-right: 10px;
          }

          .icon-text {
            .smart {
              font-size: 16px;
            }

            .medical {
              font-size: 10px;
              margin-top: 2px;
            }
          }
        }

        .menu-top-r {
          gap: 12px;

          .action-item {
            padding: 6px 10px;
          }

          .user-dropdown {
            .el-dropdown-link {
              padding: 6px 10px;

              .user-avatar {
                width: 30px;
                height: 30px;
              }
            }
          }
        }
      }
    }

    .app-body {
      width: 96%;
      gap: 14px;
      padding: 10px 0;

      .menu-l {
        .menu-card {
          border-radius: 12px;
          height: calc(100vh - 76px);

          .el-menu {
            padding: 8px 6px;

            .el-menu-item {
              height: 46px;
              line-height: 46px;
              margin: 2px 0;
              border-radius: 10px;
            }
          }
        }
      }

      .main-container {
        .content-card {
          border-radius: 12px;
          height: calc(100vh - 76px);

          > * {
            padding: 14px;
          }
        }
      }
    }
  }
}

@media (max-width: 1100px) {
  .app-container {
    .app-body {
      width: 98%;
      gap: 10px;

      .main-container {
        .content-card {
          > * {
            padding: 10px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/main.vue